module.exports = __webpack_public_path__ + "img/justify_right.bc223e81.svg";